import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from '../../../../../../common/names';
import Panel from '../../../../../../components/Panel';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../../components/Button';
import {IHolidayCalendar} from '../../../../../../types/HolidayCalendar';
import Text from '../../../../../../components/Text';
import {Grid} from '@mui/material';
import {DataGridPro} from '@mui/x-data-grid-pro';
import {holidayColumns} from '../AddEditCalendar/AddEditCalendarDialog';
import {HolidayWithId, IHoliday, IHolidayWithId} from 'types/Holiday';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type Props = {
   onClose: () => void;
   calendar?: IHolidayCalendar | null;
};

const ViewCalendarDialog: ReactFChildrenProps<Props> = memo((props) => {
   const {onClose, calendar} = props;
   const {t} = useTranslation();

   const holidays: IHolidayWithId[] = React.useMemo(
      () => calendar?.holidays.map((h: IHoliday) => HolidayWithId.cast({id: null, ...h})) || [],
      [calendar?.holidays]
   );

   if (!calendar) {
      return null;
   }

   return (
      <DialogComponent maxWidth="lg" header={DialogTypes.ViewCalendar.dialogName} close={onClose}>
         <Grid container spacing={3}>
            <Grid item sm={12} lg={6}>
               <Text name="name" value={calendar?.name} placeholder={t('Calendar Name')} />
            </Grid>
         </Grid>
         <Grid container spacing={3}>
            <Grid item sm={12} lg={8}>
               <Text
                  name="description"
                  value={calendar?.description}
                  placeholder={t('Description')}
               />
            </Grid>
         </Grid>
         <Grid container spacing={3}>
            <Grid item sm={12} lg={8}>
               <Text
                  name="nonBusinessDays"
                  value={calendar?.nonBusinessDays}
                  placeholder={t('Non-Business Days')}
               />
            </Grid>
         </Grid>
         {/* <Panel name={t('Non-Business Days')}>
        <Grid container spacing={3}>
          {
            daysOfWeek.fields.map(((day, i) => (
              
      <Grid item sm={2} lg={1} >
        <FormikCheckbox key={day.id} name="nonBusinessDays" label={day.id} value={day.display} multiple={true}  />
      </Grid>
    
            )))
          }
        </Grid>
      </Panel> */}
         <Panel name={t('Holidays')}>
            <div style={{height: 400, width: '100%'}}>
               <DataGridPro rows={holidays} columns={holidayColumns} pageSize={5} />
            </div>
         </Panel>
         <Grid container spacing={3} className="center-text">
            <Grid item>
               <Button type="button" onClick={onClose}>
                  {t('Done')}
               </Button>
            </Grid>
         </Grid>
      </DialogComponent>
   );
});

export default ViewCalendarDialog;
